/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const SET_ACCOUNT_TYPE = 'SET_ACCOUNT_TYPE';

export function setAccountType(accountType) {
    return {
        type: SET_ACCOUNT_TYPE,
        payload: accountType,
    };
}
